var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.editor
    ? _c(
        "div",
        { ref: _vm.refRichText, class: _vm.classes },
        [
          _c(
            "CompassFormItem",
            {
              attrs: {
                label: _vm.formitem.label || "",
                info: _vm.formitem.info,
                error: _vm.formitem.error || "",
                disabled: _vm.disabled,
                required: _vm.formitem.required,
                requiredLabel: _vm.formitem.requiredLabel,
                size: _vm.formitem.size || "medium",
                tooltip: _vm.formitem.tooltip || ""
              }
            },
            [
              _vm.showAIComponents
                ? _c("RichTextBubbleMenu", {
                    attrs: {
                      editorBubbleMenu: _vm.editor,
                      options: _vm.options,
                      typeRichText: _vm.typeRichText,
                      hash: _vm.hash
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showAIComponents && _vm.showLoader
                ? _c("SellsyAILoadingDialog")
                : _vm._e(),
              _vm._v(" "),
              _c("editor-content", {
                class: _vm.editorClass,
                attrs: {
                  editor: _vm.editor,
                  extensions: _vm.editorExtensions,
                  "data-ref": _vm.refRichText
                },
                on: { focus: _vm.handleEditorFocus, blur: _vm.handleEditorBlur }
              }),
              _vm._v(" "),
              _vm._t("drag-handle"),
              _vm._v(" "),
              _vm.showRichTextMenu
                ? _c("RichTextMenu", {
                    attrs: {
                      editorMenu: _vm.editor,
                      options: _vm.options,
                      typeRichText: _vm.typeRichText,
                      disabled: _vm.disabled,
                      hash: _vm.hash,
                      attachmentEndpoint: _vm.attachmentEndpoint
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "more-custom-options",
                          fn: function() {
                            return [_vm._t("more-custom-options")]
                          },
                          proxy: true
                        },
                        {
                          key: "actions",
                          fn: function() {
                            return [_vm._t("actions")]
                          },
                          proxy: true
                        },
                        {
                          key: "more-block",
                          fn: function() {
                            return [_vm._t("more-block")]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }